var initialized,
    $window,
    body,
    is_chrome,
    is_explorer,
    is_explorer_11,
    is_firefox,
    is_safari,
    is_edge,
    is_opera,
    xsMax,
    smMax,
    mdMax,
    lgMax,
    smMin,
    mdMin,
    lgMin,
    xlMin,
    mobile;

function mobileCheck() {
    if (!initialized) {
        throw 'Browser and mobile detections are not initialized! Call initDetections() first.';
    }

    mobile = mdMax;

    if(mobile) {
        body.removeClass('not-mobile');
        body.addClass('mobile');
        return true;
    } else {
        body.removeClass('mobile');
        body.addClass('not-mobile');
        return false;
    }
}

function initDetections() {
    var $ = jQuery;
    
    initialized = true;

    $window = $(window);
    body = $('body');

    // browser sniffing
    is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
    is_explorer_11 = navigator.userAgent.indexOf('rv:11.0') > -1;
    is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    is_safari = navigator.userAgent.indexOf("Safari") > -1;
    is_edge = navigator.userAgent.indexOf("Edge") > -1;
    is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
    if (is_chrome && is_safari) {
        is_safari = false;
    }
    if (is_chrome && is_opera) {
        is_chrome = false;
    }
    if (is_edge) {
        is_chrome = false;
        is_safari = false;
    }

    if (!is_explorer && !is_explorer_11 && !is_edge) {
        body.addClass('browser-not-microsoft');
    }
    if (is_safari) {
        body.addClass('browser-safari');
    }
    if (is_edge) {
        body.addClass('browser-edge');
    }
    if (is_explorer) {
        body.addClass('browser-ie');
    }
    if (is_explorer_11) {
        body.addClass('browser-ie11');
    }

    // window size variables (bootstrap 4)
    xsMax     = Modernizr.mq('(max-width:575px)');
    smMax     = Modernizr.mq('(max-width:767px)');
    mdMax     = Modernizr.mq('(max-width:991px)');
    lgMax     = Modernizr.mq('(max-width:1199px)');
    smMin     = Modernizr.mq('(min-width:576px)');
    mdMin     = Modernizr.mq('(min-width:768px)');
    lgMin     = Modernizr.mq('(min-width:992px)');
    xlMin     = Modernizr.mq('(min-width:1200px)');

    $window.on('resize', function(){
        xsMax     = Modernizr.mq('(max-width:575px)');
        smMax     = Modernizr.mq('(max-width:767px)');
        mdMax     = Modernizr.mq('(max-width:991px)');
        lgMax     = Modernizr.mq('(max-width:1199px)');
        smMin     = Modernizr.mq('(min-width:576px)');
        mdMin     = Modernizr.mq('(min-width:768px)');
        lgMin     = Modernizr.mq('(min-width:992px)');
        xlMin     = Modernizr.mq('(min-width:1200px)');

        mobileCheck();
    });

    mobileCheck();
}

export { initDetections, mobileCheck, is_chrome, is_explorer, is_explorer_11, is_firefox, is_safari, is_edge, is_opera, xsMax, smMax, mdMax, lgMax, smMin, mdMin, lgMin, xlMin, mobile };